import { getDominantColor } from 'data/utils/photo';
import { getUserThumbnail } from 'data/utils/user';
import { ItemThumbnailSize } from 'constants/images';
import { getItemThumbnail, getItemPhotosThumbnails } from 'data/utils/item';
import { transformPhotoDto } from './photo';
import { transformItemPhotoDtos } from './item';
import { transformItemAlertDto } from './item-alert';
import { transformCurrencyAmountDto, transformCurrencyAmountDtoOrString } from './currency-amount';
import { transformIconBadges } from './icon-badges';
export const transformPartialUserDtoToProductItemUser = user => ({
  id: user.id,
  login: user.login,
  photo: user.photo ? transformPhotoDto(user.photo) : null,
  thumbnailUrl: getUserThumbnail(user.photo),
  profileUrl: user.profile_url,
  isBusiness: user.business
});
export const transformItemDtoToProductItem = item => ({
  id: item.id,
  title: item.title,
  url: item.url,
  photos: transformItemPhotoDtos(item.photos),
  viewCount: item.view_count,
  favouriteCount: item.favourite_count,
  brandTitle: item.brand,
  sizeTitle: item.size,
  user: transformPartialUserDtoToProductItemUser(item.user),
  priceWithDiscount: item.discount_price ? transformCurrencyAmountDtoOrString(item.discount_price, item.currency) : null,
  price: transformCurrencyAmountDto(item.price),
  serviceFee: item.service_fee ? transformCurrencyAmountDtoOrString(item.service_fee, item.currency) : null,
  totalItemPrice: item.total_item_price ? transformCurrencyAmountDtoOrString(item.total_item_price, item.currency) : undefined,
  thumbnailUrl: getItemThumbnail(item.photos, ItemThumbnailSize.Large),
  dominantColor: getDominantColor(item.photos),
  badge: item.badge,
  itemAlertType: item.item_alert_type,
  itemAlert: item.item_alert && transformItemAlertDto(item.item_alert),
  itemClosingAction: item.item_closing_action,
  isPromoted: item.promoted,
  isDraft: item.is_draft,
  isReserved: item.is_reserved,
  isHidden: item.is_hidden,
  isClosed: item.is_closed,
  isFavourite: item.is_favourite,
  isProcessing: item.is_processing,
  isVasGalleryPromoted: item.vas_gallery_promoted,
  canPushUp: item.can_push_up,
  canVasGalleryPromote: item.can_vas_gallery_promote,
  areStatsVisible: item.stats_visible,
  iconBadges: transformIconBadges(item.icon_badges)
});
export const transformCatalogItemDtoToProductItem = item => ({
  id: item.id,
  title: item.title,
  url: item.url,
  favouriteCount: item.favourite_count,
  brandTitle: item.brand_title,
  sizeTitle: item.size_title,
  priceWithDiscount: item.discount ? transformCurrencyAmountDtoOrString(item.discount, item.discount.currency_code) : null,
  price: transformCurrencyAmountDtoOrString(item.price, item.price.currency_code),
  badge: item.badge,
  serviceFee: item.service_fee ? transformCurrencyAmountDtoOrString(item.service_fee, item.service_fee.currency_code) : null,
  totalItemPrice: item.total_item_price ? transformCurrencyAmountDtoOrString(item.total_item_price, item.total_item_price.currency_code) : undefined,
  isPromoted: item.promoted,
  isFavourite: item.is_favourite,
  thumbnailUrl: item.photo && getItemThumbnail([item.photo], ItemThumbnailSize.Large),
  dominantColor: item.photo && getDominantColor([item.photo]),
  user: transformPartialUserDtoToProductItemUser(item.user),
  photos: item.photo && transformItemPhotoDtos([item.photo]) || [],
  iconBadges: transformIconBadges(item.icon_badges)
});
export const transformFeedItemDtoToProductItem = item => ({
  id: item.id,
  title: item.title,
  url: item.url,
  favouriteCount: item.favourite_count,
  brandTitle: item.brand_title,
  sizeTitle: item.size_title,
  priceWithDiscount: item.discount ? transformCurrencyAmountDtoOrString(item.discount, item.currency) : null,
  price: transformCurrencyAmountDtoOrString(item.price, item.currency),
  serviceFee: item.service_fee ? transformCurrencyAmountDtoOrString(item.service_fee, item.currency) : null,
  totalItemPrice: item.total_item_price ? transformCurrencyAmountDtoOrString(item.total_item_price, item.currency) : undefined,
  badge: item.badge,
  isPromoted: item.promoted,
  isFavourite: item.is_favourite,
  thumbnailUrl: item.photo && getItemThumbnail([item.photo], ItemThumbnailSize.Large),
  dominantColor: item.photo && getDominantColor([item.photo]),
  user: transformPartialUserDtoToProductItemUser(item.user),
  photos: item.photo && transformItemPhotoDtos([item.photo]) || [],
  iconBadges: transformIconBadges(item.icon_badges)
});
export const transformFavouriteItemDtoToProductItem = item => ({
  id: item.id,
  title: item.title,
  url: item.url,
  favouriteCount: item.favourite_count,
  brandTitle: item.brand_title,
  sizeTitle: item.size_title,
  priceWithDiscount: item.discount ? transformCurrencyAmountDtoOrString(item.discount, item.currency) : null,
  price: transformCurrencyAmountDtoOrString(item.price, item.currency),
  serviceFee: item.service_fee ? transformCurrencyAmountDtoOrString(item.service_fee, item.currency) : null,
  totalItemPrice: item.total_item_price ? transformCurrencyAmountDtoOrString(item.total_item_price, item.currency) : undefined,
  badge: item.badge,
  isPromoted: item.promoted,
  isFavourite: item.is_favourite,
  thumbnailUrl: item.photo && getItemThumbnail([item.photo], ItemThumbnailSize.Large),
  dominantColor: item.photo && getDominantColor([item.photo]),
  user: transformPartialUserDtoToProductItemUser(item.user),
  photos: item.photo && transformItemPhotoDtos([item.photo]) || [],
  isReserved: item.is_reserved,
  isClosed: item.is_closed,
  itemClosingAction: item.item_closing_action
});
export const transformHomepageItemDtoToProductItem = item => ({
  id: item.id,
  title: item.title,
  user: {
    id: item.user_id,
    isBusiness: item.business_user
  },
  url: item.url,
  favouriteCount: item.favourite_count,
  brandTitle: item.brand_title,
  sizeTitle: item.size_title,
  priceWithDiscount: item.discount ? transformCurrencyAmountDtoOrString(item.discount, item.currency) : null,
  price: transformCurrencyAmountDtoOrString(item.price, item.currency),
  serviceFee: item.service_fee ? transformCurrencyAmountDtoOrString(item.service_fee, item.currency) : null,
  totalItemPrice: item.total_item_price ? transformCurrencyAmountDtoOrString(item.total_item_price, item.currency) : undefined,
  badge: item.badge,
  itemClosingAction: item.item_closing_action,
  isPromoted: item.promoted,
  isFavourite: item.is_favourite,
  isHidden: item.is_hidden,
  isReserved: item.is_reserved,
  isClosed: item.is_closed,
  thumbnailUrl: item.photo && getItemThumbnail([item.photo], ItemThumbnailSize.Large),
  dominantColor: item.photo && getDominantColor([item.photo]),
  photos: item.photo && transformItemPhotoDtos([item.photo]) || [],
  iconBadges: transformIconBadges(item.icon_badges)
});
export const transformHomepageBlockItemDtoToProductItem = item => ({
  id: item.id,
  title: item.title,
  user: {
    id: item.user.id,
    isBusiness: item.user.business,
    login: item.user.login,
    profileUrl: item.user.profile_url
  },
  url: item.url,
  favouriteCount: item.favourite_count,
  brandTitle: item.brand_title || '',
  sizeTitle: item.size_title || '',
  priceWithDiscount: item.discount ? transformCurrencyAmountDtoOrString(item.discount, item.currency) : null,
  price: transformCurrencyAmountDtoOrString(item.price, item.currency),
  serviceFee: item.service_fee ? transformCurrencyAmountDtoOrString(item.service_fee, item.currency) : null,
  totalItemPrice: item.total_item_price ? transformCurrencyAmountDtoOrString(item.total_item_price, item.currency) : undefined,
  badge: item.badge,
  itemClosingAction: item.item_closing_action,
  isPromoted: item.promoted,
  isFavourite: item.is_favourite,
  isHidden: item.is_hidden,
  isReserved: item.is_reserved,
  isClosed: item.is_closed,
  thumbnailUrl: item.photo && getItemThumbnail([item.photo], ItemThumbnailSize.Large),
  dominantColor: item.photo && getDominantColor([item.photo]),
  photos: item.photo && transformItemPhotoDtos([item.photo]) || [],
  contentSource: item.content_source,
  iconBadges: transformIconBadges(item.icon_badges)
});

const transformClosetPromotionPhotos = item => {
  if (item.photos && item.photos.length > 0) {
    return transformItemPhotoDtos(item.photos);
  }

  if (!item.photo) return [];
  return transformItemPhotoDtos([item.photo]);
};

const tranaformClosetPromotionItemsThumbnails = item => {
  if (item.photos && item.photos.length > 0) {
    return getItemPhotosThumbnails(item.photos, ItemThumbnailSize.Large);
  }

  if (!item.photo) return undefined;
  return getItemPhotosThumbnails([item.photo], ItemThumbnailSize.Large);
};

const tranaformClosetPromotionItemThumbnail = item => {
  if (item.photos && item.photos.length > 0) {
    return getItemThumbnail(item.photos, ItemThumbnailSize.Large);
  }

  if (!item.photo) return null;
  return getItemThumbnail([item.photo], ItemThumbnailSize.Large);
};

const transformClosetPromotionItemDominantColor = item => {
  if (item.photos && item.photos.length > 0) {
    return getDominantColor(item.photos);
  }

  if (!item.photo) return null;
  return getDominantColor([item.photo]);
};

export const transformClosetPromotionItemDtoToProductItem = item => ({
  id: item.id,
  title: item.title,
  user: {
    id: item.user_id,
    isBusiness: item.business_user
  },
  url: item.url,
  favouriteCount: item.favourite_count,
  brandTitle: item.brand_title,
  sizeTitle: item.size_title,
  priceWithDiscount: item.discount ? transformCurrencyAmountDtoOrString(item.discount, item.currency) : null,
  price: transformCurrencyAmountDtoOrString(item.price, item.currency),
  serviceFee: item.service_fee ? transformCurrencyAmountDtoOrString(item.service_fee, item.currency) : null,
  totalItemPrice: item.total_item_price ? transformCurrencyAmountDtoOrString(item.total_item_price, item.currency) : undefined,
  badge: item.badge,
  isFavourite: item.is_favourite,
  thumbnailUrl: tranaformClosetPromotionItemThumbnail(item),
  thumbnailUrls: tranaformClosetPromotionItemsThumbnails(item),
  dominantColor: transformClosetPromotionItemDominantColor(item),
  photos: transformClosetPromotionPhotos(item),
  iconBadges: transformIconBadges(item.icon_badges)
});
export const transformItemDtosToProductItems = items => items.map(transformItemDtoToProductItem);
export const transformCatalogItemDtosToProductItems = items => items.map(transformCatalogItemDtoToProductItem);
export const transformFeedItemDtosToProductItems = items => items.map(transformFeedItemDtoToProductItem);
export const transformHomepageItemDtosToProductItems = items => items.map(transformHomepageItemDtoToProductItem);
export const transformHomepageBlockItemDtosToProductItems = items => items.map(transformHomepageBlockItemDtoToProductItem);
export const transformClosetPromotionItemDtosToProductItems = items => items.map(transformClosetPromotionItemDtoToProductItem);

const transformVasGalleryItemThumbnails = item => {
  if (item.photos && item.photos.length > 0) {
    return getItemPhotosThumbnails(item.photos, ItemThumbnailSize.Large);
  }

  if (!item.photo) return undefined;
  return getItemPhotosThumbnails([item.photo], ItemThumbnailSize.Large);
};

export const transformVasGalleryItemDtoToProductItem = item => ({
  id: item.id,
  title: item.title,
  url: item.url,
  favouriteCount: item.favourite_count,
  brandTitle: item.brand_title,
  sizeTitle: item.size_title,
  priceWithDiscount: item.discount ? transformCurrencyAmountDtoOrString(item.discount, item.currency) : null,
  price: transformCurrencyAmountDtoOrString(item.price, item.currency),
  badge: item.badge,
  serviceFee: item.service_fee ? transformCurrencyAmountDtoOrString(item.service_fee, item.currency) : null,
  totalItemPrice: item.total_item_price ? transformCurrencyAmountDtoOrString(item.total_item_price, item.currency) : undefined,
  isPromoted: item.promoted,
  isFavourite: item.is_favourite,
  thumbnailUrl: item.photo && getItemThumbnail([item.photo], ItemThumbnailSize.Large),
  thumbnailUrls: transformVasGalleryItemThumbnails(item),
  dominantColor: item.photo && getDominantColor([item.photo]),
  user: transformPartialUserDtoToProductItemUser(item.user),
  photos: item.photo && transformItemPhotoDtos([item.photo]) || [],
  iconBadges: transformIconBadges(item.icon_badges)
});

const transformFollowingUserItemThumbnail = item => {
  if (item.photos && item.photos.length > 0) {
    return getItemThumbnail(item.photos, ItemThumbnailSize.Large);
  }

  if (!item.photo) return null;
  return getItemThumbnail([item.photo], ItemThumbnailSize.Large);
};

const transformFollowingUserItemsThumbnails = item => {
  if (item.photos && item.photos.length > 0) {
    return getItemPhotosThumbnails(item.photos, ItemThumbnailSize.Large);
  }

  if (!item.photo) return undefined;
  return getItemPhotosThumbnails([item.photo], ItemThumbnailSize.Large);
};

const transformFollowingUserItemDominantColor = item => {
  if (item.photos && item.photos.length > 0) {
    return getDominantColor(item.photos);
  }

  if (!item.photo) return null;
  return getDominantColor([item.photo]);
};

const transformFollowingUserItemPhotos = item => {
  if (item.photos && item.photos.length > 0) {
    return transformItemPhotoDtos(item.photos);
  }

  if (!item.photo) return [];
  return transformItemPhotoDtos([item.photo]);
};

export const transformFollowingUserItemDtoToProductItem = (item, isBusiness) => ({
  id: item.id,
  title: item.title,
  user: {
    id: item.user_id,
    isBusiness
  },
  url: item.url,
  favouriteCount: item.favourite_count,
  brandTitle: item.brand,
  sizeTitle: item.size,
  priceWithDiscount: item.discount && transformCurrencyAmountDtoOrString(item.discount, item.currency),
  price: transformCurrencyAmountDtoOrString(item.price, item.currency),
  serviceFee: item.service_fee && transformCurrencyAmountDtoOrString(item.service_fee, item.currency),
  totalItemPrice: item.total_item_price && transformCurrencyAmountDtoOrString(item.total_item_price, item.currency),
  badge: item.badge,
  isFavourite: item.is_favourite,
  thumbnailUrl: transformFollowingUserItemThumbnail(item),
  thumbnailUrls: transformFollowingUserItemsThumbnails(item),
  dominantColor: transformFollowingUserItemDominantColor(item),
  photos: transformFollowingUserItemPhotos(item),
  iconBadges: transformIconBadges(item.icon_badges)
});
export const transformFollowingUserItemDtosToProductItems = (items, isBusiness) => items.map(item => transformFollowingUserItemDtoToProductItem(item, isBusiness));
export const transformCollectionItemDtoToProductItem = item => ({
  id: item.id,
  title: item.title,
  url: item.url,
  photos: transformItemPhotoDtos(item.photos),
  viewCount: item.view_count,
  favouriteCount: item.favourite_count,
  brandTitle: item.brand,
  sizeTitle: item.size,
  user: transformPartialUserDtoToProductItemUser({
    business: item.business_user
  }),
  priceWithDiscount: item.discount_price ? transformCurrencyAmountDto(item.discount_price) : undefined,
  price: transformCurrencyAmountDto(item.price),
  serviceFee: item.service_fee ? transformCurrencyAmountDto(item.service_fee) : undefined,
  totalItemPrice: item.total_item_price ? transformCurrencyAmountDto(item.total_item_price) : undefined,
  thumbnailUrl: getItemThumbnail(item.photos, ItemThumbnailSize.Large),
  dominantColor: getDominantColor(item.photos),
  badge: item.badge,
  itemAlertType: item.item_alert_type,
  itemAlert: item.item_alert && transformItemAlertDto(item.item_alert),
  itemClosingAction: item.item_closing_action,
  isPromoted: item.promoted,
  isDraft: item.is_draft,
  isReserved: item.is_reserved,
  isHidden: item.is_hidden,
  isClosed: item.is_closed,
  isFavourite: item.is_favourite,
  isProcessing: item.is_processing,
  isVasGalleryPromoted: item.vas_gallery_promoted,
  canPushUp: item.can_push_up,
  canVasGalleryPromote: item.can_vas_gallery_promote,
  areStatsVisible: item.stats_visible,
  collections: item.collections,
  iconBadges: transformIconBadges(item.icon_badges)
});
export const transformCollectionItemDtosToProductItems = items => items.map(item => transformCollectionItemDtoToProductItem(item));